module.exports = __webpack_public_path__ + "static/logo-wcc-b2d5e081a41e1fc12ea5c845a325d9ff.svg";